var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1413 57.3544L1.93559 67.2809C1.03318 67.9115 0.813114 69.154 1.44406 70.0561L4.67716 74.6789C5.30811 75.5811 6.55114 75.8012 7.45356 75.1707L21.6593 65.2442C22.5617 64.6136 22.7817 63.3711 22.1508 62.469L18.9177 57.8462C18.2867 56.944 17.0437 56.7239 16.1413 57.3544Z",
    fill: "#E0C488"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0929 30.0036L86.2986 20.0771C87.201 19.4465 87.4211 18.204 86.7902 17.3019L83.5571 12.6791C82.9261 11.7769 81.6831 11.5568 80.7807 12.1873L66.575 22.1138C65.6725 22.7444 65.4525 23.9869 66.0834 24.889L69.3165 29.5118C69.9475 30.414 71.1905 30.6341 72.0929 30.0036Z",
    fill: "#E0C488"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6745 74.525C85.7163 60.9691 88.5365 36.1694 74.9736 19.1332C61.4106 2.09702 36.6006 -0.724335 19.5588 12.8315C2.51701 26.3874 -0.303174 51.1872 13.2598 68.2234C26.8227 85.2595 51.6327 88.0809 68.6745 74.525Z",
    fill: "#E0C488"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5298 71.8331C82.0845 59.4601 84.6586 36.8244 72.2792 21.2748C59.8997 5.72519 37.2546 3.15003 21.6999 15.523C6.14516 27.896 3.57107 50.5317 15.9505 66.0814C28.3299 81.631 50.975 84.2061 66.5298 71.8331Z",
    fill: "#E0C488"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.26 77.5922C58.9794 79.7209 75.8802 66.2715 78.0089 47.5521C80.1376 28.8327 66.6883 11.932 47.9689 9.80326C29.2495 7.67452 12.3487 21.1239 10.22 39.8433C8.09125 58.5627 21.5406 75.4635 40.26 77.5922Z",
    fill: "#E0C488"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4495 22.0507C59.4745 6.83751 37.5379 4.34291 22.4568 16.4793C17.1787 20.7256 13.4418 26.2046 11.3254 32.1825C13.4725 28.3439 16.3614 24.8455 19.9894 21.9306C35.0745 9.79468 57.0112 12.2893 68.9821 27.5019C76.7671 37.3921 78.4182 50.2186 74.4822 61.3187C81.2724 49.1794 80.5473 33.6133 71.4491 22.0548L71.4495 22.0507Z",
    fill: "#E0C488"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 76.3567C62.4493 76.3567 77 61.8059 77 43.8567C77 25.9074 62.4493 11.3567 44.5 11.3567C26.5507 11.3567 12 25.9074 12 43.8567C12 61.8059 26.5507 76.3567 44.5 76.3567Z",
    fill: "#ECEFF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderUser);
export default __webpack_public_path__ + "static/media/header-user.a153ee365c42afb22d722e5201747c09.svg";
export { ForwardRef as ReactComponent };